import React, { useEffect, useState } from 'react'
import styles from './UserManagementDetails.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { AppDispatch } from '../../redux/rootReducer';
import { useDispatch } from 'react-redux';
import { activateUser, deactivateUser, getUserDetails } from '../../redux/user-management/actions/userManagement.actions';
import Loader from '../common/loader/Loader';
import iconBack from '../../images/icon-chevron-left.svg';
import Toast from '../common/toast/Toast';

export interface UserDetailsProps {
    firstName: string;
    lastName: string;
    contact: string | number | null;
    reason: string | null;
    countryCode: string | number | null;
    requestType: string;
    email: string | null;
    actionDate: string | null;
}

const UserManageMentDetails = () => {
    const params = useParams();
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const { id: userId } = params;
    const [isLoading, setIsLoading] = useState(false);
    const [userDetails, setUserDetails] = useState<UserDetailsProps | null>(null);
    const [toastType, setToastType] = useState('error');
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState<string | null>(null);

    const onUserDetailSuccess = (userDetails: UserDetailsProps) => {
        setUserDetails(userDetails || null);
        setIsLoading(false);
    }

    const onUserDetailFailure = () => {
        setIsLoading(false);
        setToastMessage('No Data Found');
        setToastType('error');
        setShowToast(true)
    }

    useEffect(() => {
        if (userId) {
            setIsLoading(true);
            dispatch(getUserDetails(userId, onUserDetailSuccess, onUserDetailFailure));
        }
    }, [userId]);

    useEffect(() => {
        if (toastType) {
            setTimeout(() => {
                setShowToast(false)
            }, 4000);
        }
    }, [showToast]);

    const onActivateSuccess = async (message: string) => {
        setToastMessage(message);
        setShowToast(true);
        setToastType('success')
        if (userId) {
            await dispatch(getUserDetails(userId, onUserDetailSuccess, onUserDetailFailure));
        }
        setIsLoading(false);
    }

    const onActivateFailure = (message: string) => {
        setIsLoading(false);
        setToastMessage(message);
        setShowToast(true);
        setToastType('error')
    }

    const onActivate = () => {
        if (userId) {
            setIsLoading(true)
            dispatch(activateUser(userId, onActivateSuccess, onActivateFailure))
        }
    }

    const onDeactivateSuccess = async (message: string) => {
        setToastMessage(message);
        setShowToast(true);
        setToastType('success')
        if (userId) {
            await dispatch(getUserDetails(userId, onUserDetailSuccess, onUserDetailFailure));
        }
        setIsLoading(false);
    }

    const onDeactivateFailure = (message: string) => {
        setIsLoading(false);
        setToastMessage(message);
        setShowToast(true);
        setToastType('error')
    }

    const onDeactivate = () => {
        if (userId) {
            setIsLoading(true)
            dispatch(deactivateUser(userId, onDeactivateSuccess, onDeactivateFailure))
        }
    }

    return (
        <div className={styles.pageContainer}>
            {isLoading && <Loader />}
            <div className={styles.pageHeader}>
                <div className={styles.backBtn}>
                    <div role='button' className={styles.backIconWrapper}
                        onClick={() => {
                            navigate(`/user-management`);
                        }}
                    >
                        <img src={iconBack} alt='back icon' />
                    </div>
                    <p>User Details</p>
                </div>
            </div>

            {userDetails ? <>  <div className={styles.formWrapper}>
                <div className={styles.inputWrapper}>
                    <label>First Name</label>

                    <p>{userDetails?.firstName}</p>
                </div>

                <div className={styles.inputWrapper}>
                    <label>Last Name</label>

                    <p>{userDetails?.lastName}</p>
                </div>

                <div className={styles.inputWrapper}>
                    <label>Email</label>

                    <p>{userDetails?.email}</p>
                </div>

                <div className={styles.inputWrapper}>
                    <label>Contact No</label>

                    <p>{`+${userDetails?.countryCode} ${userDetails?.contact}`}</p>
                </div>

                <div className={styles.inputWrapper}>
                    <label>Request Type</label>

                    <p>{userDetails?.requestType}</p>
                </div>

                <div className={styles.inputWrapper}>
                    <label>Reason</label>

                    <p>{userDetails?.reason || '-'}</p>
                </div>
            </div>

                {userDetails?.actionDate === null && <div className={styles.actionBtnWrapper}>
                    <button className={styles.cancelBtn} onClick={() => navigate('/user-management')}>Cancel</button>
                    <button className={styles.btnGreen}

                        onClick={() => {
                            if (userDetails?.requestType === 'Activate Account') {
                                onActivate()
                            } else {
                                onDeactivate()
                            }
                        }}
                    >Approve</button>
                </div>}
            </>
                : (!isLoading && userDetails === null) && <p>No Data Found</p>
            }

            {showToast && <Toast type={toastType} message={toastMessage || ''} />}
        </div>
    )
}

export default UserManageMentDetails
